import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import type { TierId } from "@/pages/PricingPage";
import Modal from "@/components/ui/Modal";

interface PlanComingSoonModalProps {
  isOpen: boolean;
  tier: TierId | null;
  onClose: () => void;
}

export default function PlanComingSoonModal({
  isOpen,
  tier,
  onClose,
}: PlanComingSoonModalProps) {
  const { t } = useTranslation("pages");
  const planName = tier ? t(`pricing.tiers.${tier}.name`) : "";

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm" title={t("pricing.comingSoon.title", { plan: planName })}>
      <div className="flex flex-col gap-5">
        <p className="text-sm text-secondary-600">
          {t("pricing.comingSoon.body")}
        </p>
        <div className="flex items-center justify-end gap-3">
          <Link to="/register" className="btn-secondary px-4 py-2">
            {t("pricing.comingSoon.startFree")}
          </Link>
          <button
            type="button"
            className="btn-primary px-4 py-2"
            onClick={onClose}
          >
            {t("pricing.comingSoon.cta")}
          </button>
        </div>
      </div>
    </Modal>
  );
}
